module.exports = __webpack_public_path__ + "static/media/phone.a686e122.png";